import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
} from "@mui/material"

export const generateTableContent = (columns: string[]) => {
  const columnGroups = distributeColumns(columns)

  return (
    <>
      {columnGroups.map((columnGroup, tableIndex) => {
        const totalColumns = columnGroup.length + 1 // +1 for the row number column
        const startLetter = columnGroups.slice(0, tableIndex).flat().length

        // Generate column headers starting from the appropriate letter
        const columnHeaders = Array.from(
          { length: columnGroup.length + 1 },
          (_, i) => (i === 0 ? "" : String.fromCharCode(65 + startLetter + i - 1)),
        )

        return (
          <StyledTable key={`table-${columnGroup.length}-${columnGroup[0]}`}>
            <TableHead>
              <Row sx={{ gridTemplateColumns: `repeat(${totalColumns}, 1fr)` }}>
                {columnHeaders.map((header, index) => (
                  <HighlightCell key={`header-${tableIndex}-${header || index}`}>
                    {header}
                  </HighlightCell>
                ))}
              </Row>
            </TableHead>
            <TableBody>
              <Row sx={{ gridTemplateColumns: `repeat(${totalColumns}, 1fr)` }}>
                <HighlightCell>1</HighlightCell>
                {columnGroup.map((column) => (
                  <Cell key={`${tableIndex}-${column}`}>{column}</Cell>
                ))}
              </Row>
            </TableBody>
          </StyledTable>
        )
      })}
    </>
  )
}

// Function to distribute columns evenly across multiple tables
const MAX_DATA_COLUMS = 8
const distributeColumns = (columns: string[]): string[][] => {
  if (columns.length <= MAX_DATA_COLUMS) {
    return [columns]
  }

  const totalTables = Math.ceil(columns.length / MAX_DATA_COLUMS)
  const baseColumnsPerTable = Math.floor(columns.length / totalTables)
  const remainder = columns.length % totalTables

  const distribution: string[][] = []
  let currentIndex = 0

  for (let i = 0; i < totalTables; i++) {
    const columnsForThisTable = baseColumnsPerTable + (i < remainder ? 1 : 0)
    distribution.push(
      columns.slice(currentIndex, currentIndex + columnsForThisTable),
    )
    currentIndex += columnsForThisTable
  }

  return distribution
}

const StyledTable = styled(Table)(({ theme: { palette, spacing } }) => ({
  border: `1px solid ${palette.grey[300]}`,
  "& .MuiTableCell-root": {
    border: `1px solid ${palette.grey[300]}`,
    borderLeft: "none",
    padding: spacing(1),
    "&:last-child": {
      borderRight: "none",
    },
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    borderTop: "none",
  },
  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
    borderBottom: "none",
  },
}))

const Row = styled(TableRow)(() => ({
  display: "grid",
}))

const Cell = styled(TableCell)(({ theme: { typography, palette } }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontSize: typography.pxToRem(12),
  color: palette.grey.dark,
  backgroundColor: "white",
  fontStyle: "italic",
}))

const HighlightCell = styled(Cell)(({ theme: { palette } }) => ({
  color: palette.success.main,
  textTransform: "uppercase",
  fontStyle: "normal",
}))
